import React from "react";

export interface Checkbox {
  id: number;
  value: string;
  label: string;
  isChecked: boolean;
}

interface MultiCheckboxProps {
  checkboxes: Checkbox[];
  onToggle: (id: number) => void;
}

const MultiCheckbox: React.FC<MultiCheckboxProps> = ({
  checkboxes,
  onToggle,
}) => {
  const toggleCheckbox = (id: number) => {
    if (onToggle) {
      onToggle(id);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#e3edf9",
        paddingTop: "10px",
        borderRadius: "4px",
        width: "50%",
        marginLeft: "30%",
      }}
    >
      {checkboxes.map((checkbox) => (
        <label
          key={checkbox.id}
          style={{
            paddingLeft: "10px",
            display: "block",
            marginBottom: "8px",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>{checkbox.label}</span>
            <input
              type="checkbox"
              checked={checkbox.isChecked}
              onChange={() => toggleCheckbox(checkbox.id)}
              style={{ marginRight: "20px" }}
            />
          </div>
        </label>
      ))}
    </div>
  );
};

export default MultiCheckbox;
